/** Per-domain staleTime tiers (ms). Cached data is shown instantly while refetching after stale. */

export const STALE = {
  /** Genres catalog — rarely changes */
  static: 2 * 60 * 60 * 1000,
  /** Event detail, profiles, trending */
  semiStatic: 20 * 60 * 1000,
  /** Feed pages, people search */
  feed: 20 * 60 * 1000,
  /** User RSVPs, follow ids, profile event lists */
  user: 10 * 60 * 1000,
  /** Chats inbox, groupless rows */
  inbox: 2 * 60 * 1000,
  /** Active message threads — short stale window, not zero */
  realtime: 30 * 1000,
};

/** gcTime must exceed typical festival session length so persisted data survives in memory. */
export const GC = {
  /** A festival's offline set (map, lineup, your picks): downloaded days ahead, it must still be here at the gates. */
  festival: 7 * 24 * 60 * 60 * 1000,
  long: 48 * 60 * 60 * 1000,
  default: 24 * 60 * 60 * 1000,
  short: 60 * 60 * 1000,
};
